import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { mapMainBoxesToPortalTeasers } from "@/data/portal_main_boxes_mappers";

export function usePortalMainBoxes() {
  const store = useStore();
  const { locale } = useI18n();

  const loading = computed(() => store.getters.getSliderIsLoading);

  const teasers = computed(() =>
    mapMainBoxesToPortalTeasers(store.getters.getMainBoxes, locale.value),
  );

  return {
    loading,
    teasers,
  };
}
